// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4ab18f17","592":"8bdcf9e9","662":"093c74b8"}[chunkId] + ".chunk.js";
};